import React, { memo } from 'react';
import { CalendarIcon } from 'lucide-react';
import { TroveGenrePage } from '../../components/Trove/TroveGenrePage';
import type { TroveArticle, TroveEvent } from '../../components/Trove/TroveGenrePage';
import type { ActivityPost } from '../../components/Trove/ActivityPostCard';
const activityPosts: ActivityPost[] = [{
  id: 1,
  type: 'Event Announcement',
  title: 'London Book Fair 2024 Registration Open',
  description: 'Early bird tickets now available for the biggest publishing event of the year.',
  author: 'LBF Team',
  date: 'Oct 15, 2023',
  genre: 'Industry'
}, {
  id: 2,
  type: 'Award Nomination',
  title: 'Indie Book Awards - Shortlist Announced',
  description: "See who made the cut for this year's prestigious independent publishing awards.",
  author: 'Indie Book Awards',
  date: 'Oct 14, 2023',
  genre: 'Awards'
}, {
  id: 3,
  type: 'Event Announcement',
  title: 'Virtual Romance Con - Call for Speakers',
  description: 'We are looking for panelists for our upcoming virtual romance convention.',
  author: 'Romance Con',
  date: 'Oct 13, 2023',
  genre: 'Romance'
}];
const upcomingEvents: TroveEvent[] = [{
  name: 'London Book Fair',
  date: 'Mar 12-14, 2024',
  location: 'London, UK'
}, {
  name: 'Bouchercon 2024',
  date: 'Aug 28 - Sep 1, 2024',
  location: 'Nashville, TN'
}, {
  name: 'Romance Writers of America',
  date: 'Jul 24-27, 2024',
  location: 'Austin, TX'
}, {
  name: 'World Fantasy Convention',
  date: 'Oct 17-20, 2024',
  location: 'Niagara Falls, NY'
}];
const articles: TroveArticle[] = [{
  id: 1,
  title: 'Top Literary Conferences of 2024',
  excerpt: 'A curated guide to the most influential industry events...',
  author: 'Emily Chen',
  date: 'October 6, 2023',
  category: 'Events',
  readTime: '10 min read',
  image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Virtual Book Festivals Guide',
  excerpt: 'How to make the most of online literary events...',
  author: 'David Thompson',
  date: 'October 3, 2023',
  category: 'Events',
  readTime: '8 min read',
  image: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const interviews: TroveArticle[] = [{
  id: 109,
  title: 'Behind the Scenes of the International Book Fair',
  excerpt: 'The director shares insights on organizing a global literary event...',
  author: 'Publishing Weekly',
  date: 'October 8, 2023',
  category: 'Events',
  readTime: '12 min read',
  image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}, {
  id: 110,
  title: 'Literary Festival Planning: A Conversation with Jane Harper',
  excerpt: 'The renowned event coordinator discusses creating memorable experiences...',
  author: 'Literary Events Magazine',
  date: 'October 2, 2023',
  category: 'Events',
  readTime: '14 min read',
  image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}];
const podcasts: TroveArticle[] = [{
  id: 209,
  title: 'The Publishing Show',
  excerpt: 'Weekly discussions on industry trends, events, and networking opportunities...',
  author: 'Mark Williams',
  date: 'Weekly',
  category: 'Industry',
  readTime: '45-50 min episodes',
  image: 'https://images.unsplash.com/photo-1516321165247-4aa89a48be28?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}, {
  id: 210,
  title: 'Literary Event Horizon',
  excerpt: 'Previews and reviews of major book fairs, conferences, and festivals...',
  author: 'Laura Chen & Thomas Miller',
  date: 'Bi-weekly',
  category: 'Events',
  readTime: '40-60 min episodes',
  image: 'https://images.unsplash.com/photo-1560523159-4a9692d222f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}];
const EventsTrove = () => <TroveGenrePage title="Industry Events" subtitle="Stay updated on literary conferences, festivals, and workshops" icon={<CalendarIcon className="h-6 w-6" data-id="element-17149" data-mp="2xa7qi8s0omgw" />} searchPlaceholder="Search industry events content..." activityPosts={activityPosts} activityTitle="Latest Event News" articles={articles} interviews={interviews} podcasts={podcasts} upcomingEvents={upcomingEvents} featuredSectionTitle="Featured Event Guide" interviewsTabLabel="Organizer Interviews" podcastsTabLabel="Industry Podcasts" eventsSectionTitle="Major Upcoming Events" eventsLinkLabel="View full calendar" data-id="element-17148" data-mp="20l9vqqk9oojq" />;
export default EventsTrove;